module.exports = __webpack_public_path__ + "static/media/OnScreenText_1.273a49f5.gif";